<template>
  <div class="page-wrap document-edit">
    <div class="page-con">
      <div class="page-con-scroll">
        <slot name="header" />
        <div class="field-item" v-for="field in formList" v-if="field.show" :key="field.key">
          <base-input
            v-if="field.fieldType === 'input'"
            :title="field.name"
            :placeholder="field.placeholder"
            :extraConstraint="field.positiveConstraint"
            :number-only="false"
            :one-line="false"
            :read-only="!field.editable"
            :required="field.required"
            v-model="field.value"
          />
          <base-input-numeric
            v-else-if="field.fieldType === 'baseInputNumeric'"
            :title="field.name"
            :one-line="field.oneLine"
            :required="field.required"
            :read-only="!field.editable"
            :placeholder="field.placeholder"
            v-model="field.value"
            :isFormatByThousands="field.isFormatByThousands"
            :unit="field.extraProps.unit"
            :mode="field.extraProps.mode"
            :integerMaxLength="field.extraProps.integerMaxLength || 8"
            :decimalMaxLength="field.extraProps.decimalMaxLength || 0"
          >
          </base-input-numeric>
          <base-textarea
            v-else-if="field.fieldType === 'baseTextarea'"
            :title="field.name"
            :required="field.required"
            :max-length="field.maxLength"
            :read-only="!field.editable"
            :placeholder="field.placeholder"
            v-model="field.value"
          ></base-textarea>
          <base-date-select
            v-else-if="field.fieldType === 'baseDateSelect'"
            :placeholder="field.placeholder"
            :read-only="!field.editable"
            :title="field.name"
            v-model="field.value"
            :show-clear-dot="field.showClearDot"
            :required="field.required"
            :min-date="field.extraProps.minDate"
            :max-date="field.extraProps.maxDate"
            @clear-click="onClearClick(field)"
          >
          </base-date-select>
          <base-select
            v-else-if="field.fieldType === 'baseSelect'"
            :show-clear-dot="field.showClearDot"
            :title="field.name"
            :required="field.required"
            :value="field.showValue"
            :placeholder="field.placeholder"
            :read-only="!field.editable"
            @click="onFieldClick(field)"
            @clear-click="onClearClick(field)"
          />
          <template v-else>
            <slot name="fieldCom" :field="field" />
          </template>
        </div>
      </div>
    </div>
    <slot name="footer">
      <!-- 底部按钮 -->
      <page-footer v-if="buttonList.length > 0" :buttons="buttonList" @menuClick="menuClick" />
    </slot>
  </div>
</template>

<script>
import baseInput from 'components/base-ui/base-input';
import baseSelect from 'components/base-ui/base-select/index';
import baseTextarea from '@/components/base-ui/base-textarea';
import BaseDateSelect from 'components/base-ui/base-date-select';
import PageFooter from 'components/business/common/page-footer';

export default {
  name: 'index',
  data() {
    return {
      menClickMap: {
        delete: this.handleDelete,
        save: this.handleSave,
        cancel: this.handleCancel,
      },
    };
  },
  props: {
    formList: Array,
    default() {
      return [];
    },
  },
  computed: {
    buttonList() {
      return [
        {
          code: 'delete',
          type: 'danger',
          flex: 2,
          name: 'delete',
        },
        {
          code: 'cancel',
          type: 'default',
          flex: 4,
          name: 'cancel',
        },
        {
          code: 'save',
          type: 'primary',
          flex: 4,
          name: 'save',
        },
      ];
    },
  },
  methods: {
    onClearClick(field) {
      field.value = '';
      field.showValue = '';
      this.$emit('clearField', field);
    },
    onFieldClick(field) {
      this.$emit('onFieldClick', field);
    },
    handleDelete() {
      this.$handPlugin.confirm.show({
        title: '确定删除？',
        rightClick: () => {
          this.$emit('handleDelete');
        },
      });
    },
    handleSave() {
      let errorFlag = this.valid();
      if (!errorFlag) {
        this.$emit('handleSave');
      }
    },
    handleCancel() {
      this.hlyRouter.go(-1);
    },
    valid() {
      let errorFlag = false;
      let errorMsg = [];
      this.formList.forEach((field) => {
        if (field.required && !field.value) {
          errorMsg.push(`${field.name}必填`);
        }
      });
      if (errorMsg.length > 0) {
        this.$handPlugin.toast.show(errorMsg.join(','));
        errorFlag = true;
      }
      return errorFlag;
    },
    menuClick(item) {
      let action = this.menClickMap[item.code];
      if (action) {
        action();
      } else {
        this.$emit('menuClick', item);
      }
      // if (this.formList)
    },
  },
  components: {
    baseInput,
    baseSelect,
    PageFooter,
    baseTextarea,
    BaseDateSelect,
    baseInputNumeric: () => import('components/base-ui/base-input-numeric'),
  },
};
</script>

<style lang="scss">
.document-edit {
  position: absolute;
  .page-con {
    bottom: 120px;
  }

  .field-item {
    & + .field-item {
      margin-top: 20px;
    }
  }
}
</style>
